import styled from 'styled-components'

export const StyledLocalProfile = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  img {
    width: 36px;
    height: 36px;
  }

  span {
    font-size: 1.6rem;
  }
`
